import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  forgetPasswordFormWrapper: {
    padding: theme.spacing(0, 50),
    boxSizing: 'content-box',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
      textAlign: 'center',
      padding: theme.spacing(30),
      boxSizing: 'border-box',
      width: '100%',
      maxWidth: theme.spacing(320),
    },

    '& > h1': {
      textAlign: 'left',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(30, 15, 0),
    },
  },
  forgetPasswordContainer: {
    paddingTop: theme.spacing(24),
    maxWidth: theme.spacing(175),
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
      padding: theme.spacing(26, 0),
      maxWidth: 'unset',
    },
  },
  subtitle: {
    fontSize: theme.spacing(10),
    lineHeight: '26px',
    paddingTop: theme.spacing(10),
    color: '#707070',
    fontFamily: 'Roboto',
    fontWeight: theme.spacing(200),
  },
  emailInputWrapper: {
    paddingBottom: theme.spacing(15),

    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(8),
    },
  },
}));
